

<div id="">
   <header id="banner" role="banner">
      <nav class="site-breadcrumbs" id="breadcrumbs">
         <!--<h1> <span>Elementi Navigazione</span> </h1>--> 
         <ul class="breadcrumbs breadcrumbs-horizontal lfr-component">
            <li class="first"><span><a routerLink="">SIRA</a></span></li>
            <li><span><a href="/sirang/miinteressa">AREE TEMATICHE</a></span></li>
            <li class="last"><span><a href="/sirang/agentifisici1">AGENTI FISICI</a></span></li>
         </ul>
      </nav>
   </header>
   <div id="content">
      <div class="portlet-boundary portlet-boundary_103_ portlet-static portlet-static-end " id="p_p_id_103_">
         <span id="p_103"></span> 
         <div class="portlet-body"> </div>
      </div>
      <div class="columns-2" id="main-content" role="main">
         <div class="portlet-layout">
            <div class="aui-w70 portlet-column portlet-column-first" id="column-1">
               <div class="portlet-dropzone portlet-column-content portlet-column-content-first" id="layout-column_column-1">
                  <div class="portlet-boundary portlet-boundary_56_ portlet-journal-content  portlet-draggable" id="p_p_id_56_INSTANCE_Po3d2aHX2DSd_">
                     <span id="p_56_INSTANCE_Po3d2aHX2DSd"></span> 
                     <div class="portlet-body">
                        <section class="portlet" id="portlet_56_INSTANCE_Po3d2aHX2DSd">
                           <table style="width: 100%;">
                              <tbody>
                                 <tr>
                                    
                                    <td>
                                       <header class="portlet-topper gradient">
                                          <h1 class="portlet-title"> <span class="portlet-title-text portlet-title-editable" style="margin-left: 0px;">Agenti fisici</span> </h1>
                                       </header>
                                    </td>
                                 </tr>
                              </tbody>
                           </table>
                           <div class="portlet-content">
                              <div class=" portlet-content-container" style="">
                                 <div class="portlet-body">
                                    <div class="journal-content-article">
                                       <p> l modulo dedicato agli <strong>Agenti Fisic</strong>i supporta gli enti nelle attività di gestione di 2 principali ambiti, il primo comprende il tema dei campi elettromagnetici, il secondo il tema dell'acustica e del rumore:</p>
                                       <ol>
                                          <li> <strong>Radiazioni generate da un campo elettromagnetico;</strong></li>
                                       </ol>
                                       <p> In base alla frequenza le radiazioni generate da un campo elettromagnetico si distinguono in due macro aree:</p>
                                       <ol style="list-style-type:lower-alpha;">
                                          <li> Radiazioni ionizzanti <strong>(IR)</strong> ovvero radiazioni ad intensa energia (frequenza dell'onda elettromagnetica più elevata) che possono rompere i legami atomici dei corpi colpiti e ionizzati; le sorgenti di tali radiazioni risiedono nei fenomeni di radioattività naturale o artificiale;</li>
                                          <li> Radiazioni non ionizzanti <strong>(NIR),</strong> solitamente note come CEM (campi elettromagnetici), caratterizzate da un'energia la cui intensità non permette di modificare la struttura atomica e molecolare dei corpi colpiti (frequenza dell'onda elettromagnetica meno elevata).</li>
                                       </ol>
                                       <p style="margin-left:36.0pt;"> A loro volta le <strong>NIR </strong>vengono suddivise in:</p>
                                       <ul>
                                          <li> Frequenze estremamente basse <strong>(Extremely Low Frequency - ELF</strong>), le cui principali sorgenti sono costituite dagli <strong>elettrodott</strong>i per il trasferimento di energia ad alta e media tensione <strong>(AT - MT</strong>);</li>
                                          <li> Radiofrequenza <strong>(RF)</strong>, le cui principali sorgenti sono costituite dagli impianti di ricetrasmissione radio e Tv;</li>
                                          <li> <strong>Microonde (MO),</strong> le cui principali sorgenti sono costituite dagli impianti di telefonia cellulare (stazioni Radio Base);</li>
                                       </ul>
                                       <ol>
                                          <li value="2"> <strong>Acustica e rumore: </strong>Il<strong> rumore</strong> è un fenomeno acustico distinto dal suono perché generato da onde irregolari e non periodiche, percepite come sensazioni uditive sgradevoli e fastidiose. L'orecchio umano non è ugualmente sensibile a tutte le frequenze, ma è più sensibile nel campo compreso fra 2 kHz e 5 kHz, ed è molto meno sensibile alle frequenze estremamente elevate (ultrasuoni) o estremamente basse (infrasuoni). Questo fenomeno è molto più pronunciato ai bassi livelli di pressione sonora che non agli alti livelli. L'<strong>acustica</strong> è la branca della fisica che studia il suono, le sue cause - le onde di pressione -, la sua propagazione e la sua ricezione, nello specifico <strong>l'acustica ambientale</strong> si occupa dei problemi collegati al rumore in ambiente esterno.</li>
                                       </ol>
                                    </div>
                                    <div class="entry-links"> </div>
                                 </div>
                              </div>
                           </div>
                        </section>
                     </div>
                  </div>
               </div>
            </div>
            <div class="aui-w30 portlet-column portlet-column-last" id="column-2">
               <div class="portlet-dropzone portlet-column-content portlet-column-content-last" id="layout-column_column-2">
                  <div class="portlet-boundary portlet-boundary_56_ portlet-journal-content  portlet-draggable" id="p_p_id_56_INSTANCE_ieAw63KB7TJL_">
                     <span id="p_56_INSTANCE_ieAw63KB7TJL"></span> 
                     <div class="portlet-body">
                        <section class="portlet" id="portlet_56_INSTANCE_ieAw63KB7TJL">
                           <table style="width: 100%;">
                              <tbody>
                                 <tr>
                                    
                                    <td>
                                       <header class="portlet-topper gradient">
                                          <h1 class="portlet-title"> <span class="portlet-title-text" style="margin-left: 0px;">Dati ambientali</span> </h1>
                                       </header>
                                    </td>
                                 </tr>
                              </tbody>
                           </table>
                           <div class="portlet-content">
                              <div class=" portlet-content-container" style="">
                                 <div class="portlet-body">
                                    <div class="journal-content-article">
                                       <ul>
                                          <li> <a target="_blank" href="https://portal.sardegnasira.it/web/sardegnaambiente/dati-ambientali-agenti-fisici">Vai alla pagina</a></li>
                                       </ul>
                                    </div>
                                 </div>
                              </div>
                           </div>
                        </section>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
      <form action="#" id="hrefFm" method="post" name="hrefFm"> <span></span> </form>
   </div>
</div>